import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Back from '../Back/Back';
import { serviceConsumer } from '../../network/ServiceConsumer';

// Shows the event logo on every event-scoped page that uses this title bar;
// clicking the logo returns to that event's dashboard (the manage tiles
// page). Self-contained: the event id is read from the page URL (?id=) and
// the event is resolved here, so pages don't need to pass anything extra.
const SingleLineTitle = (props) => {
    const location = useLocation()
    const navigate = useNavigate()
    const searchParams = new URLSearchParams(location.search)
    const eventId = searchParams.get('id')
    const manageType = searchParams.get('Manage')
    const [eventInfo, setEventInfo] = useState(null)

    useEffect(() => {
        if (!eventId) return
        let active = true
        const load = async () => {
            // Manage=grade pages are grade exams; everything else tries feis
            // first and falls back to grade-exam (some URLs omit Manage).
            const urls = manageType === 'grade'
                ? [`${process.env.REACT_APP_BASE_URL}/grade-exam/${eventId}`, `${process.env.REACT_APP_BASE_URL}/feis/${eventId}`]
                : [`${process.env.REACT_APP_BASE_URL}/feis/${eventId}`, `${process.env.REACT_APP_BASE_URL}/grade-exam/${eventId}`]
            for (const url of urls) {
                try {
                    const response = await serviceConsumer('GET', url)
                    const data = response?.Feis || response?.grade_exams
                    if (data && active) {
                        setEventInfo({ logo: data.logo, eventType: data.eventType })
                        return
                    }
                } catch (error) { /* try the next event type */ }
            }
        }
        load()
        return () => { active = false }
    }, [eventId])

    const logoClickHandler = () => {
        if (!eventId) return
        const isGrade = manageType === 'grade' || (eventInfo?.eventType && eventInfo.eventType !== 'Feiseanna')
        isGrade
            ? navigate(`/organizer-manage-grade?id=${eventId}&Manage=grade`)
            : navigate(`/organizer-manage-feis?id=${eventId}&Manage=feis`)
    }

    return (
        <>
            <div className="single-line-title">
                <Back onBackClick={props.onBackClick} from="single" />
                {eventId && eventInfo?.logo && (
                    <img
                        src={eventInfo.logo}
                        alt="event logo"
                        title="Back to event dashboard"
                        onClick={logoClickHandler}
                        style={{ height: '34px', width: '34px', objectFit: 'contain', borderRadius: '4px', cursor: 'pointer', marginRight: '8px' }}
                    />
                )}
                <div className="org-title-name" style={{ marginTop: "1px" }}>{props.titleName}</div>
            </div>
            <div className="hr-org-title" />
        </>
    )
}

export default SingleLineTitle
